import isNil from 'ramda/src/isNil';
import { css, FlattenSimpleInterpolation } from 'styled-components';
import { Color } from '~common/model/basics';
import { theme } from '~web/view/theme';
import { getColorCode, withAlpha } from '~web/view/theme/colors';

export enum ButtonType {
  SUBMIT = 'submit',
  RESET = 'reset',
  BUTTON = 'button',
}

export enum Size {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export const getMinHeight = (size: Size): string => {
  switch (size) {
    case Size.Large:
      return '54px';
    case Size.Small:
      return '0';
    case Size.Medium:
    default:
      return '44px';
  }
};

export const getPadding = (size: Size, fullWidth: boolean): string => {
  switch (size) {
    case Size.Small:
      return fullWidth ? '8px 8px' : '8px 24px';
    case Size.Large:
      return fullWidth ? '16px 8px' : '16px 64px';
    case Size.Medium:
    default:
      return fullWidth ? '12px 8px' : '12px 36px';
  }
};

export const getFontSize = (size: Size): string => {
  switch (size) {
    case Size.Large:
      return '18px';
    case Size.Small:
    case Size.Medium:
    default:
      return '16px';
  }
};

const getBackgroundColorCode = (color: Color): string => {
  switch (color) {
    case Color.White:
      return theme.colors.white;
    case Color.Black:
      return theme.colors.black;
    case Color.Gray:
      return theme.colors.gray.v3;
    case Color.DimGray:
      return theme.colors.gray.v6;
    case Color.Transparent:
      return 'transparent';
    case Color.Purple:
    default:
      return theme.colors.purple.primary;
  }
};

export const getBackgroundColor = (color: Color, transparency?: number): string => {
  const colorCode = getBackgroundColorCode(color);
  return isNil(transparency) ? colorCode : withAlpha(colorCode)(transparency);
};

const getTextColor = (color: Color): string => {
  switch (color) {
    case Color.White:
      return theme.colors.black;
    case Color.Gray:
    case Color.DimGray:
    case Color.Purple:
    default:
      return theme.colors.white;
  }
};

const getBackgroundDisabledColorCode = (color: Color): string => {
  switch (color) {
    case Color.Purple:
      return theme.colors.purple.inactive;
    case Color.DimGray:
    case Color.Gray:
      return theme.colors.gray.v15;
    default:
      return getBackgroundColor(color);
  }
};

const getBackgroundDisabledColor = (color: Color, transparency?: number): string => {
  const colorCode = getBackgroundDisabledColorCode(color);
  return isNil(transparency) ? colorCode : withAlpha(colorCode)(transparency);
};

export const getTextDisabledColor = (color: Color): string => {
  switch (color) {
    case Color.Purple:
      return theme.colors.gray.v1;
    case Color.DimGray:
      return theme.colors.gray.v10;
    default:
      return getTextColor(color);
  }
};

export const getColorStyle = (
  color: Color,
  colorTransparency?: number,
  textColor?: Color,
): FlattenSimpleInterpolation => {
  return css`
    color: ${isNil(textColor) ? getTextColor(color) : getColorCode(textColor)};
    background: ${getBackgroundColor(color, colorTransparency)};
  `;
};

export const getDisabledColorStyle = (
  color: Color,
  colorTransparency?: number,
  textColor?: Color,
): FlattenSimpleInterpolation => {
  return css`
    color: ${isNil(textColor) ? getTextDisabledColor(color) : getColorCode(textColor)};
    background: ${getBackgroundDisabledColor(color, colorTransparency)};
  `;
};



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/common/src/components/button/button.helper.ts